// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ef3E","col":"styles_col__2GT1H"};